import { matchPath, useHistory, useLocation } from 'react-router-dom';
import classNames from 'classnames';

import TestimonialsIcon from '@svg/testimonials.svg';
import HeartIcon from '@svg/heart.svg';
import Home from '@svg/home.svg';
import UserIcon from '@svg/user-new.svg';
import PlusIcon from '@svg/plus.svg';
import {
  favouriteProducts,
  mainPage,
} from '@legacyUrls';
import {
  addNewProduct,
  dialogsList,
  login,
} from '@urls';
import { useHeaderState } from '@hook/useHeaderState';
import { useDesktopOrWider } from '@utils/mediaQuery';
import { Image } from '@ui/Image';
import { Button } from '@ui/Button';
import { Link } from '@ui/Link';
import { MobileBottomBarUserMenu, UserMenuLink } from '@components/MobileBottomBarUserMenu';

import s from './MobileBottomBar.sss';

interface User {
  id: number,
  username: string,
  avatar?: string | null,
  unreadMessagesCount: number,
  hasUnreadNotifications?: boolean | null,
  isSeller: boolean,
}

interface Props {
  className?: string,
  user?: User | null,
  userMenuLinks: UserMenuLink[],
}

export const MobileBottomBar: React.FC<Props> = ({
  className,
  user,
  userMenuLinks,
}) => {
  const isDesktop = useDesktopOrWider();
  const history = useHistory();
  const location = useLocation();

  const {
    isHeaderUserMenuOpen,
    handleCloseHeaderUserMenu,
    handleToggleHeaderUserMenu,
  } = useHeaderState();

  const handleProfileClick = () => {
    if (user) {
      handleToggleHeaderUserMenu();
    } else {
      window.location.href = history.createHref({ pathname: login });
    }
  };

  return (
    <>
      <div className={classNames(s.root, className)}>
        <Link
          className={classNames(s.slot, s.ripple, {
            [s.slotStateActive]: matchPath(location.pathname, { path: mainPage, exact: true }),
          })}
          theme='black'
          href={history.createHref({ pathname: mainPage })}
        >
          <Home
            className={s.icon}
            width='24'
            height='24'
          />
        </Link>

        <Button
          className={classNames(s.slot, s.ripple, {
            [s.slotStateActive]: matchPath(location.pathname, dialogsList),
          })}
          theme="text"
          onClick={() => {
            window.location.href = history.createHref({
              pathname: dialogsList,
            });
          }}
        >
          <TestimonialsIcon
            className={classNames(s.icon, s.testimonialsIcon)}
            width='24'
            height='24'
          />
          {!!user?.unreadMessagesCount && (
            <span className={s.unreadMessagesCount}>
              {user.unreadMessagesCount}
            </span>
          )}
        </Button>

        <div className={s.slot}>
          <Button
            className={classNames(s.addProductButton, s.ripple)}
            theme="text"
            onClick={() => {
              window.location.href = history.createHref({
                pathname: addNewProduct,
              });
            }}
          >
            <PlusIcon
              className={s.icon}
              width='24'
              height='24'
            />
          </Button>
        </div>

        <Button
          className={classNames(s.slot, s.ripple, {
            [s.slotStateActive]: matchPath(location.pathname, favouriteProducts),
          })}
          theme="text"
          onClick={() => {
            window.location.href = history.createHref({
              pathname: favouriteProducts,
            });
          }}
        >
          <HeartIcon
            className={s.icon}
            width='24'
            height='24'
          />
        </Button>

        <Button
          className={classNames(s.slot, s.ripple)}
          theme="text"
          onClick={handleProfileClick}
        >
          {user ? (
            <Image
              className={s.image}
              src={user?.avatar || '#'} 
              alt="avatar"
            />
          ) : (
            <UserIcon
              className={s.icon}
              width='24'
              height='24'
            />
          )}
        </Button>
      </div>

      <MobileBottomBarUserMenu
        isOpen={isHeaderUserMenuOpen && !isDesktop}
        onClose={handleCloseHeaderUserMenu}
        links={userMenuLinks}
      />
    </>
  );
};
